const T_PREFIX = "confirmation-popup";

export const confirmationPopupTrns = {
  description: `${T_PREFIX}.description`,
  yesButton: `${T_PREFIX}.yes-btn`,
  noButton: `${T_PREFIX}.no-btn`,
};
